// extracted by mini-css-extract-plugin
export var container = "_g9-0";
export var content = "_g9-3";
export var customerTitle = "_g9-4";
export var empty = "_g9-5";
export var gray = "_g9-6";
export var header = "_g9-7";
export var info = "_g9-8";
export var loading = "_g9-2";
export var loadingCard = "_g9-9";
export var oneLine = "_g9-a";
export var personName = "_g9-e";
export var pillContainer = "_g9-b";
export var selected = "_g9-1";
export var text = "_g9-c";
export var twoLines = "_g9-d";
export var unread = "_g9-f";
export var unreadIndicator = "_g9-g";